import React from 'react';
import { Photo } from '../../../../types';
import { PhotoDisplayData } from '../../../../types/PhotoDisplayData';
import ImagePhotoItem from './ImagePhotoItem';
import VideoPhotoItem from './VideoPhotoItem';

interface PhotoItemProps {
    photo: Photo;
    photoData?: PhotoDisplayData;
    index: number;
    totalPhotos?: number;
}

const PhotoItem: React.FC<PhotoItemProps> = (props) =>
    props.photo.type === 'video' ? <VideoPhotoItem {...props} /> : <ImagePhotoItem {...props} />;

export default PhotoItem;
